import '@babel/runtime/helpers/esm/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { TOKEN_PREFIX, extract as extract$1 } from './hooks/useCacheToken.js';
import { CSS_VAR_PREFIX, extract as extract$2 } from './hooks/useCSSVarRegister.js';
import { STYLE_PREFIX, extract } from './hooks/useStyleRegister.js';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@babel/runtime/helpers/esm/typeof';
import './StyleContext.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/createSuper';
import './theme/createTheme.js';
import '../../../../../rc-util@5.44.4_react-dom@18.3.1_react@18.3.1/node_modules/rc-util/es/warning.js';
import './theme/ThemeCache.js';

var _ExtractStyleFns;
(_ExtractStyleFns = {}, _defineProperty(_ExtractStyleFns, STYLE_PREFIX, extract), _defineProperty(_ExtractStyleFns, TOKEN_PREFIX, extract$1), _defineProperty(_ExtractStyleFns, CSS_VAR_PREFIX, extract$2), _ExtractStyleFns);
